import { render, staticRenderFns } from "./HairColorsRegistryList.vue?vue&type=template&id=389ecc6e"
import script from "./HairColorsRegistryList.vue?vue&type=script&lang=js"
export * from "./HairColorsRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports